import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethodName } from '../../content/enums/payment/payment-method-name';

@Pipe({
  name: 'keyToIcon'
})
export class KeyToIconPipe implements PipeTransform {

  transform(key: PaymentMethodName): string {
    switch (key) {
      case PaymentMethodName.CREDITCARD: return 'pi pi-credit-card';
      case PaymentMethodName.PAYPAL: return 'pi pi-paypal';
      case PaymentMethodName.APPLEPAY: return 'pi pi-apple';
      case PaymentMethodName.GOOGLEPAY: return 'pi pi-google';
    }
    return null;
  }

}
